import { render, staticRenderFns } from "./Qna.vue?vue&type=template&id=dc5eade4&"
import script from "./Qna.vue?vue&type=script&lang=ts&"
export * from "./Qna.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports